export default "__VITE_ASSET__BV1GdrFF__"